var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100%"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"106"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }